module.exports = __webpack_public_path__ + "static/media/redwood6.22aa8777.jpg";